export function extractCompanyImageId(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') return null;
  const withoutQuery = imageUrl.split('?')[0];
  const parts = withoutQuery.split('/').filter(Boolean);
  const last = parts[parts.length - 1];
  const id = Number(last);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function resolveImageIdAtIndex(index, companyImages, companyImageMeta) {
  const meta = companyImageMeta?.[index];
  if (meta?.imageId) return Number(meta.imageId);

  const url = companyImages?.[index];
  return extractCompanyImageId(url);
}

export function normalizeCompanyImageMeta(companyImageMeta) {
  if (!companyImageMeta?.length) return [];

  const rows = companyImageMeta.map((row) => ({
    imageId: Number(row.imageId ?? row.id),
    isPrimary: Boolean(row.isPrimary),
    isLogo: Boolean(row.isLogo),
    logoVariant: row.logoVariant || null,
  }));

  const flagged = rows.filter((row) => row.isPrimary && row.imageId);
  const primaryId = flagged.length === 1
    ? flagged[0].imageId
    : flagged.length > 1
      ? flagged[0].imageId
      : rows[0]?.imageId ?? null;

  if (!primaryId) return rows;

  return rows.map((row) => ({
    ...row,
    isPrimary: Number(row.imageId) === Number(primaryId),
  }));
}

export function resolvePrimaryImageId(companyImageMeta, companyImages, companyData) {
  const normalized = normalizeCompanyImageMeta(companyImageMeta);
  const flagged = normalized.filter((row) => row.isPrimary && row.imageId);

  if (flagged.length === 1) {
    return Number(flagged[0].imageId);
  }

  if (companyData?.primaryCompanyImageId) {
    return Number(companyData.primaryCompanyImageId);
  }

  const fromMeta = normalized[0]?.imageId;
  if (fromMeta) return Number(fromMeta);

  return extractCompanyImageId(companyImages?.[0]) ?? null;
}

export function isPrimaryImage(imageId, primaryImageId) {
  if (!imageId || !primaryImageId) return false;
  return Number(imageId) === Number(primaryImageId);
}
